function makeDataAutoId(...args){return function(...args2){return args[0]?[...args,...args2].filter(Boolean).join("-"):void 0}}export{makeDataAutoId as default};
